<template>
  <head>
    <meta charset="utf-8" />
    <title>CBHI | Community-Based Health Insurance</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Keep your finances and membership up to date" name="description" />
    <meta content="Kelvin Njuguna Ndungu" name="author" />
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body data-sidebar="dark">
  <div id="layout-wrapper">
    <header id="page-topbar">
      <div class="navbar-header">
        <div class="d-flex">
          <div class="navbar-brand-box">
            <a href="index.html" class="logo logo-dark">
              <span class="logo-sm"><img src="assets/images/logo.svg" alt="" height="22"></span>
              <span class="logo-lg"><img src="assets/images/logo-dark.png" alt="" height="17"></span>
            </a>
            <a href="index.html" class="logo logo-light">
              <span class="logo-sm"><img src="assets/images/the-logo.png" alt="" height="50"></span>
              <span class="logo-lg"><img src="assets/images/logo-text-white.png" alt="" height="55"></span>
            </a>
          </div>
          <button type="button" class="btn btn-sm px-3 font-size-16 header-item waves-effect" id="vertical-menu-btn">
            <i class="fa fa-fw fa-bars"></i>
          </button>
          <div class="phone-logo d-md-none d-sm-flex"><img src="assets/images/color-log0.svg" alt="" class="img"></div>
          <form class="app-search d-none d-lg-block">
            <div class="position-relative">
              <input v-model="searchQuery" @input="performSearch" type="text" class="form-control" placeholder="Search...">
              <span class="bx bx-search-alt"></span>
            </div>
          </form>
        </div>

        <div class="d-flex">
          <div class="dropdown d-inline-block d-lg-none ms-2">
            <button type="button" class="btn header-item noti-icon waves-effect" data-bs-toggle="dropdown">
              <i class="mdi mdi-magnify"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
              <form class="p-3">
                <div class="form-group m-0">
                  <div class="input-group">
                    <input v-model="searchQuery" @input="performSearch" type="text" class="form-control" placeholder="Search ...">
                    <div class="input-group-append">
                      <button class="btn btn-primary" type="submit"><i class="mdi mdi-magnify"></i></button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div class="dropdown d-none d-lg-inline-block ms-1">
            <button type="button" class="btn header-item noti-icon waves-effect" data-bs-toggle="fullscreen">
              <i class="bx bx-fullscreen"></i>
            </button>
          </div>

          <div class="dropdown d-inline-block">
            <button type="button" class="btn header-item waves-effect" data-bs-toggle="dropdown">
              <img id="header-lang-img" src="assets/images/flags/us.jpg" alt="Header Language" height="16">
            </button>
            <div class="dropdown-menu dropdown-menu-end">
              <a href="javascript:void(0);" class="dropdown-item notify-item language" data-lang="en">
                <img src="assets/images/flags/us.jpg" alt="user-image" class="me-1" height="12"> <span class="align-middle">English</span>
              </a>
              <a href="javascript:void(0);" class="dropdown-item notify-item language" data-lang="sw">
                <img src="assets/images/flags/kenya.png" alt="user-image" class="me-1" height="12"> <span class="align-middle">Swahili</span>
              </a>
            </div>
          </div>

          <div class="dropdown d-inline-block">
            <button type="button" class="btn header-item waves-effect" data-bs-toggle="dropdown">
              <img class="rounded-circle header-profile-user" src="assets/images/users/avatar-1.jpg" alt="Header Avatar">
              <span class="d-none d-xl-inline-block ms-1">{{ userName }}</span>
              <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-end">
              <a class="dropdown-item" href="myprofile.html"><i class="bx bx-user font-size-16 align-middle me-1"></i> My Profile</a>
              <a class="dropdown-item" href="my-logs.html"><i class="bx bx-time font-size-16 align-middle me-1"></i> My Logs</a>
              <a class="dropdown-item" href="auth-lock-screen.html"><i class="bx bx-lock-open font-size-16 align-middle me-1"></i> Lock screen</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item text-danger" @click="logout"><i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i> Logout</a>
            </div>
          </div>
        </div>
      </div>
    </header>

    <NavigationBar/>

    <div class="main-content">
      <div class="page-content">
        <div class="container-fluid">
          <!-- Page Title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Members Management</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Dashboard</a></li>
                    <li class="breadcrumb-item active">Members</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Current Date Display - Compact -->
          <div class="row mb-2">
            <div class="col-12">
              <div class="d-flex align-items-center justify-content-between bg-light border rounded px-3 py-2">
                <div class="d-flex align-items-center">
                  <i class="bx bx-calendar text-primary me-2 font-size-18"></i>
                  <span class="fw-semibold me-2">Today:</span>
                  <span>{{ currentDateDisplay }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Alerts -->
          <div v-if="alert.success" class="alert alert-success alert-dismissible fade show" role="alert">
            {{ message }}
            <button type="button" class="btn-close" @click="clearAlerts"></button>
          </div>
          <div v-if="alert.info" class="alert alert-primary alert-dismissible fade show" role="alert">
            {{ message }}
            <button type="button" class="btn-close" @click="clearAlerts"></button>
          </div>
          <div v-if="alert.failed" class="alert alert-danger alert-dismissible fade show" role="alert">
            {{ message }}
            <button type="button" class="btn-close" @click="clearAlerts"></button>
          </div>

          <!-- Statistics Dashboard -->
          <div class="row">
            <div class="col-lg-2 col-md-4">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Members on Page</p>
                      <h5 class="mb-0">{{ formatNumber(members.length) }}</h5>
                      <small class="text-muted">of {{ formatNumber(totalMembers) }} total</small>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-primary rounded-circle text-white font-size-20">
                        <i class="bx bx-user-circle"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-2 col-md-4">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Active Members</p>
                      <h5 class="mb-0">{{ formatNumber(currentPageStats.activeMembers) }}</h5>
                      <small class="text-muted">{{ currentPageStats.activePercentage }}% of page</small>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-success rounded-circle text-white font-size-20">
                        <i class="bx bx-check-circle"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-2 col-md-4">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">CBHI Members</p>
                      <h5 class="mb-0">{{ formatNumber(currentPageStats.cbhiMembers) }}</h5>
                      <small class="text-muted">{{ currentPageStats.cbhiPercentage }}% of page</small>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-info rounded-circle text-white font-size-20">
                        <i class="bx bx-id-card"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-2 col-md-4">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Avg. Household Size</p>
                      <h5 class="mb-0">{{ currentPageStats.avgFamilySize }}</h5>
                      <small class="text-muted">on current page</small>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-warning rounded-circle text-white font-size-20">
                        <i class="bx bx-group"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-2 col-md-4">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Total Annual</p>
                      <h5 class="mb-0">{{ formatCurrency(currentPageStats.totalAnnualPayments) }}</h5>
                      <small class="text-muted">on current page</small>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-purple rounded-circle text-white font-size-20">
                        <i class="bx bx-money"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-2 col-md-4">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Avg. Annual</p>
                      <h5 class="mb-0">{{ formatCurrency(currentPageStats.avgAnnualPayment) }}</h5>
                      <small class="text-muted">per member</small>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-danger rounded-circle text-white font-size-20">
                        <i class="bx bx-receipt"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white border-bottom">
                  <!-- Filter Bar Row 1 -->
                  <div class="row g-3 align-items-center">
                    <div class="col-lg-3 col-md-4">
                      <div class="search-box">
                        <div class="position-relative">
                          <input v-model="localSearchQuery" @input="debounceSearch" type="text" class="form-control bg-light border-light rounded" placeholder="Search members...">
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-2 col-md-3">
                      <select v-model="filters.status" @change="applyFilters" class="form-select form-select-sm">
                        <option value="">All Status</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                        <option value="expired">Expired</option>
                        <option value="deleted">Deleted</option>
                        <option value="archived">Archived</option>
                      </select>
                    </div>

                    <div class="col-lg-2 col-md-3">
                      <select v-model="filters.planId" @change="applyFilters" class="form-select form-select-sm">
                        <option value="">All Plans</option>
                        <option v-for="plan in availablePlans" :key="plan.plan_id" :value="plan.plan_id">
                          {{ plan.plan_name }}
                        </option>
                      </select>
                    </div>

                    <div class="col-lg-1 col-md-2">
                      <select v-model="filters.cardIssued" @change="applyFilters" class="form-select form-select-sm">
                        <option value="">All Cards</option>
                        <option value="1">Issued</option>
                        <option value="0">Not Issued</option>
                      </select>
                    </div>

                    <div class="col-lg-2 col-md-3">
                      <div class="btn-group w-100" role="group">
                        <button type="button" @click="showColumnModal = true" class="btn btn-light btn-sm" title="Column Visibility">
                          <i class="bx bx-columns"></i>
                        </button>
                        <button type="button" @click="showSortModal = true" class="btn btn-light btn-sm" title="Sort">
                          <i class="bx bx-sort-alt-2"></i>
                        </button>
                        <button type="button" @click="exportData" class="btn btn-success btn-sm" title="Export Current Page">
                          <i class="bx bx-download"></i>
                        </button>
                        <button type="button" @click="startExportAll" class="btn btn-primary btn-sm" title="Export All">
                          <i class="bx bx-cloud-download"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Location Filters Row -->
                  <div class="row g-3 align-items-center mt-2">
                    <div class="col-lg-2 col-md-4">
                      <select v-model="filters.countyId" @change="onFilterCountyChange" class="form-select form-select-sm">
                        <option value="">All Counties</option>
                        <option v-for="county in counties" :key="county.county_id" :value="county.county_id">
                          {{ county.county_name }}
                        </option>
                      </select>
                    </div>

                    <div class="col-lg-2 col-md-4">
                      <select v-model="filters.subCountyId" @change="onFilterSubCountyChange" class="form-select form-select-sm" :disabled="!filters.countyId">
                        <option value="">All Sub-Counties</option>
                        <option v-for="subCounty in filterSubCounties" :key="subCounty.sub_county_id" :value="subCounty.sub_county_id">
                          {{ subCounty.sub_county_name }}
                        </option>
                      </select>
                    </div>

                    <div class="col-lg-2 col-md-4">
                      <select v-model="filters.wardId" @change="applyFilters" class="form-select form-select-sm" :disabled="!filters.subCountyId">
                        <option value="">All Wards</option>
                        <option v-for="ward in filterWards" :key="ward.ward_id" :value="ward.ward_id">
                          {{ ward.ward_name }}
                        </option>
                      </select>
                    </div>

                    <div class="col-lg-2 col-md-4">
                      <button type="button" @click="resetFilters" class="btn btn-outline-danger btn-sm w-100" v-if="activeFiltersCount > 0">
                        <i class="bx bx-refresh me-1"></i> Reset ({{ activeFiltersCount }})
                      </button>
                    </div>
                  </div>

                  <!-- Date Range Filter Row -->
                  <div class="row mt-3">
                    <div class="col-12">
                      <div class="bg-light border rounded p-2">
                        <div class="row g-2 align-items-center">
                          <div class="col-auto">
                            <span class="badge bg-secondary">From</span>
                          </div>
                          <div class="col-auto">
                            <input
                                v-model="dateRange.startDate"
                                type="date"
                                class="form-control form-control-sm"
                                style="width: 150px;">
                          </div>

                          <div class="col-auto">
                            <span class="text-muted">—</span>
                          </div>

                          <div class="col-auto">
                            <span class="badge bg-secondary">To</span>
                          </div>
                          <div class="col-auto">
                            <input
                                v-model="dateRange.endDate"
                                type="date"
                                class="form-control form-control-sm"
                                style="width: 150px;">
                          </div>

                          <div class="col-auto">
                            <button type="button" class="btn btn-primary btn-sm" @click="applyDateFilter" :disabled="!isValidDateRange" title="Apply Filter">
                              <i class="bx bx-filter-alt"></i> Apply
                            </button>
                          </div>
                          <div class="col-auto" v-if="hasDateSelection">
                            <button type="button" class="btn btn-outline-danger btn-sm" @click="clearDateFilter" title="Clear Filter">
                              <i class="bx bx-x"></i> Clear
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-3">Loading members...</p>
                  </div>

                  <div v-else class="table-responsive">
                    <table class="table align-middle table-hover contacts-table border table-striped text-nowrap" id="membersTable">
                      <thead class="table-light">
                      <tr>
                        <th v-if="visibleColumns.memberCode" scope="col">CBHI Number</th>
                        <th v-if="visibleColumns.name" scope="col">Name</th>
                        <th v-if="visibleColumns.enrollmentType" scope="col">Type</th>
                        <th v-if="visibleColumns.plan" scope="col">Plan Category</th>
                        <th v-if="visibleColumns.professional" scope="col">Profession</th>
                        <th v-if="visibleColumns.county" scope="col">County</th>
                        <th v-if="visibleColumns.ward" scope="col">Ward</th>
                        <th v-if="visibleColumns.location" scope="col">Location</th>
                        <th v-if="visibleColumns.address" scope="col">Address</th>
                        <th v-if="visibleColumns.familySize" scope="col" class="text-center">Household Size</th>
                        <th v-if="visibleColumns.registrationDate" scope="col">Registration</th>
                        <th v-if="visibleColumns.lastPayment" scope="col">Last Payment</th>
                        <th v-if="visibleColumns.cardIssued" scope="col" class="text-center">Card Issue Notes</th>
                        <th v-if="visibleColumns.status" scope="col" class="text-center">Status</th>
                        <th v-if="visibleColumns.nextPayment" scope="col">Expiry</th>
                        <th v-if="visibleColumns.annualPayment" class="text-end" scope="col">Annual</th>
                        <th class="text-end">Actions</th>
                      </tr>
                      </thead>
                      <tbody class="border">
                      <tr v-for="member in members" :key="member.member_id">
                        <td v-if="visibleColumns.memberCode" class="fw-bold">{{ member.cbhi_number || member.member_code }}</td>
                        <td v-if="visibleColumns.name">
                          <div>
                            <strong>{{ member.full_name }}</strong>
                            <small class="d-block text-muted">{{ member.phone_number }}</small>
                          </div>
                        </td>
                        <td v-if="visibleColumns.enrollmentType">
                          <span class="badge rounded-pill" :class="{ 'bg-primary': member.enrollment_type === 'cbhi_member', 'bg-secondary': member.enrollment_type === 'non_cbhi_member' }">
                            {{ member.enrollment_type === 'cbhi_member' ? 'CBHI' : 'Non-CBHI' }}
                          </span>
                        </td>
                        <td v-if="visibleColumns.plan">
                          <div v-if="member.enrollment_type === 'cbhi_member'">
                            <span class="badge bg-info text-dark fw-bold">{{ getPlanName(member.selected_plan_id) }}</span>
                            <small class="d-block text-muted">{{ getPlanType(member.selected_plan_id) }}</small>
                          </div>
                          <span v-else class="text-muted">N/A</span>
                        </td>
                        <td v-if="visibleColumns.professional">{{ member.occupation || 'N/A' }}</td>
                        <td v-if="visibleColumns.county">{{ member.county_name }}</td>
                        <td v-if="visibleColumns.ward">{{ member.ward_name }}</td>
                        <td v-if="visibleColumns.location">{{ member.location_name }}</td>
                        <td v-if="visibleColumns.address" class="text-truncate" style="max-width: 150px;" :title="member.address">{{ member.address }}</td>
                        <td v-if="visibleColumns.familySize" class="text-center">
                          {{ member.household_size }}
                          <small class="d-block text-muted">({{ calculateDependentStatus(member) }})</small>
                        </td>
                        <td v-if="visibleColumns.registrationDate" class="text-nowrap">
                          <div>{{ formatDate(member.registration_date) }}</div>
                          <small class="text-muted">{{ getTimeSinceRegistration(member.registration_date) }}</small>
                        </td>
                        <td v-if="visibleColumns.lastPayment" class="text-nowrap">
                          <div>{{ formatDate(member.last_payment_date) || 'N/A' }}</div>
                          <small v-if="member.last_payment_amount" class="text-muted">{{ formatCurrency(member.last_payment_amount) }}</small>
                        </td>
                        <td v-if="visibleColumns.cardIssued" class="text-center">
                          <span v-if="member.cbhi_card_issued === '1' || member.cbhi_card_issued === 1" class="badge bg-success">
                            <i class="bx bx-id-card me-1"></i> Issued
                          </span>
                          <span v-else class="badge bg-warning text-dark">
                            <i class="bx bx-id-card me-1"></i> Not Issued
                          </span>
                          <div v-if="member.cbhi_card_issued === '1' || member.cbhi_card_issued === 1" class="mt-1">
                            <small class="d-block text-muted">{{ formatDate(member.card_issue_date) }}</small>
                            <small v-if="member.card_issue_notes" class="d-block text-primary fw-bold">{{ member.card_issue_notes }}</small>
                          </div>
                        </td>
                        <td v-if="visibleColumns.status" class="text-center">
                          <span class="badge rounded-pill text-uppercase" :class="{
                            'bg-success': member.status === 'active',
                            'bg-danger': member.status === 'inactive',
                            'bg-warning': member.status === 'expired',
                            'bg-secondary': member.status === 'suspended',
                            'bg-dark': member.status === 'deleted',
                            'bg-info': member.status === 'archived'
                          }">
                            {{ member.status }}
                          </span>
                        </td>
                        <td v-if="visibleColumns.nextPayment" class="text-nowrap">
                          <div>{{ formatDate(member.expiry_date) }}</div>
                          <small class="text-muted" :class="getExpiryStatus(member.expiry_date).class">
                            {{ getExpiryStatus(member.expiry_date).text }}
                          </small>
                        </td>
                        <td v-if="visibleColumns.annualPayment" class="text-end fw-bold text-nowrap">
                          <span v-if="member.enrollment_type === 'cbhi_member'">{{ formatCurrency(member.annual_premium) }}</span>
                          <span v-else>N/A</span>
                        </td>
                        <td class="text-uppercase text-end text-nowrap">
                          <a href="#" @click.prevent="viewMemberDetails(member)" class="text-primary text-decoration-none">
                            <i class="bx bx-show font-size-16 align-middle me-1"></i> Details
                          </a>
                          |
                          <a href="#" @click.prevent="openEditPaymentDateModal(member)" class="text-info text-decoration-none" :class="{'disabled': !member.last_payment_date}">
                            <i class="bx bx-edit font-size-16 align-middle me-1"></i> Edit Payment
                          </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <div v-if="members.length === 0 && !loading" class="text-center py-5">
                      <i class="bx bx-search-alt display-1 text-muted"></i>
                      <p class="text-muted">No members found</p>
                      <p class="text-muted">Try adjusting your search criteria or filters</p>
                    </div>

                    <!-- Pagination -->
                    <div v-if="totalPages > 1" class="row mt-3">
                      <div class="col-lg-12">
                        <nav aria-label="Page navigation">
                          <ul class="pagination justify-content-center mb-0">
                            <li class="page-item" :class="{ disabled: currentPage === 1 }">
                              <a class="page-link" @click="changePage(currentPage - 1)" href="javascript:void(0)">Previous</a>
                            </li>
                            <li v-for="page in displayedPages" :key="page" class="page-item" :class="{ active: page === currentPage }">
                              <a class="page-link" @click="changePage(page)" href="javascript:void(0)">{{ page }}</a>
                            </li>
                            <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                              <a class="page-link" @click="changePage(currentPage + 1)" href="javascript:void(0)">Next</a>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Column Visibility Modal -->
      <div v-if="showColumnModal" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5)">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Column Visibility</h5>
              <button type="button" class="btn-close" @click="showColumnModal = false"></button>
            </div>
            <div class="modal-body">
              <div v-for="(visible, column) in visibleColumns" :key="column" class="form-check form-switch mb-2">
                <input class="form-check-input" type="checkbox" :id="`column-${column}`" v-model="visibleColumns[column]">
                <label class="form-check-label" :for="`column-${column}`">{{ getColumnLabel(column) }}</label>
              </div>
              <div class="mt-3">
                <button type="button" @click="showAllColumns" class="btn btn-sm btn-outline-primary me-2">Show All</button>
                <button type="button" @click="hideAllColumns" class="btn btn-sm btn-outline-danger">Hide All</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sort Modal -->
      <div v-if="showSortModal" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5)">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Sort by field</h5>
              <button type="button" class="btn-close" @click="showSortModal = false"></button>
            </div>
            <div class="modal-body">
              <div class="mb-3">
                <label class="form-label">Field</label>
                <select v-model="sortField" class="form-select">
                  <option value="">Select field</option>
                  <option value="cbhi_number">CBHI Number</option>
                  <option value="full_name">Name</option>
                  <option value="occupation">Profession</option>
                  <option value="county_name">County</option>
                  <option value="ward_name">Ward</option>
                  <option value="location_name">Location</option>
                  <option value="household_size">Household Size</option>
                  <option value="registration_date">Registration Date</option>
                  <option value="status">Status</option>
                  <option value="enrollment_type">Enrollment Type</option>
                  <option value="selected_plan_id">Plan Category</option>
                  <option value="cbhi_card_issued">Card Issued</option>
                </select>
              </div>
              <div class="mb-3">
                <div class="btn-group" role="group">
                  <input type="radio" class="btn-check" name="sortDirection" id="sortAsc" value="asc" v-model="sortDirection">
                  <label class="btn btn-outline-secondary" for="sortAsc"><i class="bx bx-sort-up"></i> Ascending</label>
                  <input type="radio" class="btn-check" name="sortDirection" id="sortDesc" value="desc" v-model="sortDirection">
                  <label class="btn btn-outline-secondary" for="sortDesc"><i class="bx bx-sort-down"></i> Descending</label>
                </div>
              </div>
              <button type="button" @click="applySort" class="btn btn-primary w-100">Apply Sort</button>
              <button type="button" @click="clearSort" class="btn btn-outline-danger w-100 mt-2">
                <i class="bx bx-trash me-1"></i> Clear Sort
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Edit Payment Date Modal -->
      <div class="modal fade" id="editPaymentDateModal" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Last Payment Date</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
              <div v-if="editPaymentData.member">
                <div class="mb-3">
                  <label class="form-label"><strong>Member:</strong></label>
                  <p class="mb-1">{{ editPaymentData.member.full_name }}</p>
                  <small class="text-muted">{{ editPaymentData.member.cbhi_number }}</small>
                </div>

                <div class="mb-3">
                  <label class="form-label"><strong>Current Payment Date:</strong></label>
                  <p class="text-primary mb-0">{{ formatDate(editPaymentData.member.last_payment_date) }}</p>
                </div>

                <div class="mb-3">
                  <label class="form-label"><strong>New Payment Date:</strong> <span class="text-danger">*</span></label>
                  <input
                      v-model="editPaymentData.newDate"
                      type="date"
                      class="form-control"
                      :max="todayDate">
                  <small class="form-text text-muted mt-1 d-block">Select date (not future dates)</small>
                </div>

                <div v-if="editPaymentData.error" class="alert alert-danger py-2">
                  {{ editPaymentData.error }}
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary" @click="updatePaymentDate" :disabled="editPaymentData.loading || !editPaymentData.newDate">
                <span v-if="editPaymentData.loading">
                  <span class="spinner-border spinner-border-sm me-1"></span> Updating...
                </span>
                <span v-else><i class="bx bx-save me-1"></i> Update Date</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">© CBHI</div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">Ministry of Health</div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
  <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import { authUrl, executeJson } from "@/api";
import router from "@/router";

export default {
  name: "MembersAll",
  components: { NavigationBar },

  data() {
    return {
      // Currency configuration (can be changed per deployment)
      currencyCode: 'KES',
      currencySymbol: 'KES',

      // Loading states
      loading: false,
      searchTimeout: null,

      // User info
      userName: '',

      // Members data
      members: [],
      totalMembers: 0,
      currentPage: 1,
      itemsPerPage: 50,

      // CBHI Plans
      availablePlans: [],
      plansMap: {},

      // Search and filters
      searchQuery: '',
      localSearchQuery: '',
      sortField: '',
      sortDirection: 'asc',
      dateRange: {
        startDate: '',
        endDate: ''
      },
      filters: {
        status: '',
        enrollmentType: '',
        planId: '',
        countyId: '',
        subCountyId: '',
        wardId: '',
        cardIssued: ''
      },

      // Location data
      counties: [],
      filterSubCounties: [],
      filterWards: [],

      // UI States
      showColumnModal: false,
      showSortModal: false,

      // Column visibility
      visibleColumns: {
        memberCode: true,
        name: true,
        enrollmentType: true,
        plan: true,
        professional: true,
        county: false,
        ward: true,
        location: true,
        address: false,
        familySize: true,
        registrationDate: true,
        lastPayment: true,
        cardIssued: true,
        status: true,
        nextPayment: true,
        annualPayment: true
      },

      // Alert states
      alert: { success: false, info: false, failed: false },
      message: '',

      // Edit Payment Date State
      editPaymentData: {
        member: null,
        newDate: '',
        loading: false,
        error: null
      }
    };
  },

  computed: {
    currentDateDisplay() {
      return new Date().toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },

    todayDate() {
      return new Date().toISOString().split('T')[0];
    },

    totalPages() {
      return Math.ceil(this.totalMembers / this.itemsPerPage);
    },

    displayedPages() {
      const pages = [];
      const startPage = Math.max(1, this.currentPage - 2);
      const endPage = Math.min(this.totalPages, startPage + 4);
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
      return pages;
    },

    activeFiltersCount() {
      let count = 0;
      if (this.filters.status) count++;
      if (this.filters.enrollmentType) count++;
      if (this.filters.planId) count++;
      if (this.filters.countyId) count++;
      if (this.filters.subCountyId) count++;
      if (this.filters.wardId) count++;
      if (this.filters.cardIssued) count++;
      if (this.dateRange.startDate && this.dateRange.endDate) count++;
      return count;
    },

    hasDateSelection() {
      return this.dateRange.startDate || this.dateRange.endDate;
    },

    isValidDateRange() {
      return this.dateRange.startDate && this.dateRange.endDate;
    },

    currentPageStats() {
      if (!this.members || this.members.length === 0) {
        return {
          activeMembers: 0, inactiveMembers: 0, cbhiMembers: 0, nonCbhiMembers: 0,
          cardsIssued: 0, avgFamilySize: 0, activePercentage: 0, inactivePercentage: 0,
          cbhiPercentage: 0, cardsIssuedPercentage: 0, totalAnnualPayments: 0, avgAnnualPayment: 0
        };
      }

      const totalOnPage = this.members.length;
      const activeMembers = this.members.filter(m => m.status === 'active').length;
      const inactiveMembers = this.members.filter(m => m.status === 'inactive').length;
      const cbhiMembers = this.members.filter(m => m.enrollment_type === 'cbhi_member').length;
      const nonCbhiMembers = this.members.filter(m => m.enrollment_type === 'non_cbhi_member').length;
      const cardsIssued = this.members.filter(m => m.cbhi_card_issued === '1' || m.cbhi_card_issued === 1).length;

      const totalFamilySize = this.members.reduce((sum, member) => sum + (parseInt(member.household_size) || 1), 0);
      const avgFamilySize = totalOnPage > 0 ? (totalFamilySize / totalOnPage).toFixed(1) : 0;

      const activePercentage = totalOnPage > 0 ? Math.round((activeMembers / totalOnPage) * 100) : 0;
      const cbhiPercentage = totalOnPage > 0 ? Math.round((cbhiMembers / totalOnPage) * 100) : 0;

      const totalAnnualPayments = this.members.reduce((sum, member) => sum + (parseFloat(member.annual_premium) || 0), 0);
      const avgAnnualPayment = totalOnPage > 0 ? Math.round(totalAnnualPayments / totalOnPage) : 0;

      return {
        activeMembers, inactiveMembers, cbhiMembers, nonCbhiMembers, cardsIssued,
        avgFamilySize, activePercentage, cbhiPercentage, totalAnnualPayments, avgAnnualPayment
      };
    }
  },

  mounted() {
    this.loadUserInfo();
    this.loadInitialData();
  },

  methods: {
    // ==================== DATE FORMATTING ====================

    formatDate(dateString) {
      if (!dateString) return '';
      const d = new Date(dateString);
      return d.toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' });
    },

    getTimeSinceRegistration(registrationDate) {
      if (!registrationDate) return '';

      const now = new Date();
      const regDate = new Date(registrationDate);
      const diffTime = Math.abs(now - regDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays === 0) return 'Today';
      if (diffDays === 1) return '1 day ago';
      if (diffDays < 7) return `${diffDays} days ago`;
      if (diffDays < 30) return `${Math.ceil(diffDays / 7)} weeks ago`;
      if (diffDays < 365) return `${Math.ceil(diffDays / 30)} months ago`;
      return `${Math.floor(diffDays / 365)} years ago`;
    },

    getExpiryStatus(expiryDate) {
      if (!expiryDate) return { text: 'No expiry', class: 'text-muted' };

      const now = new Date();
      const expiry = new Date(expiryDate);
      const diffTime = expiry - now;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays < 0) return { text: `Expired ${Math.abs(diffDays)} days ago`, class: 'text-danger' };
      else if (diffDays <= 30) return { text: `Expires in ${diffDays} days`, class: 'text-warning' };
      else if (diffDays <= 90) return { text: `${diffDays} days left`, class: 'text-info' };
      else return { text: `${diffDays} days left`, class: 'text-success' };
    },

    applyDateFilter() {
      if (this.isValidDateRange) {
        this.currentPage = 1;
        this.loadMembers();
      }
    },

    clearDateFilter() {
      this.dateRange = { startDate: '', endDate: '' };
      this.currentPage = 1;
      this.loadMembers();
    },

    // ==================== DATA LOADING METHODS ====================

    viewMemberDetails(member) {
      sessionStorage.setItem('member', JSON.stringify(member));
      router.push({ name: 'member-details', params: { cbhi_number: member.cbhi_number } });
    },

    loadUserInfo() {
      this.userName = (sessionStorage.getItem("firstName") || '') + " " + (sessionStorage.getItem("lastName") || '') || "User";
    },

    async loadInitialData() {
      await this.loadAvailablePlans();
      await this.loadCounties();
      await this.loadMembers();
    },

    async loadAvailablePlans() {
      try {
        const res = await executeJson({ "function": "getAvailablePlans" }, authUrl);
        if (res.data.success) {
          this.availablePlans = res.data.data.plans || [];
          this.plansMap = {};
          this.availablePlans.forEach(plan => { this.plansMap[plan.plan_id] = plan; });
        }
      } catch (e) {
        console.error("Failed to load plans:", e);
      }
    },

    clearAlerts() {
      this.alert = { success: false, info: false, failed: false };
    },

    showAlert(type, msg) {
      this.clearAlerts();
      this.alert[type] = true;
      this.message = msg;
      if (type === 'success' || type === 'info') {
        setTimeout(() => { this.clearAlerts(); }, 5000);
      }
    },

    async loadMembers() {
      this.loading = true;
      const data = {
        "function": "searchMembers",
        "searchTerm": this.searchQuery || "",
        "countyId": this.filters.countyId || null,
        "subCountyId": this.filters.subCountyId || null,
        "wardId": this.filters.wardId || null,
        "status": this.filters.status || null,
        "enrollmentType": this.filters.enrollmentType || null,
        "planId": this.filters.planId || null,
        "cardIssued": this.filters.cardIssued || null,
        "startDate": this.dateRange.startDate || null,
        "endDate": this.dateRange.endDate || null,
        "sortField": this.sortField || null,
        "sortDirection": this.sortDirection || 'asc',
        "limit": this.itemsPerPage,
        "offset": (this.currentPage - 1) * this.itemsPerPage
      };

      try {
        const res = await executeJson(data, authUrl);
        if (res.data.success && res.data.data.success) {
          this.members = res.data.data.data.members || [];
          this.totalMembers = res.data.data.data.total || 0;
        } else {
          this.showAlert('failed', res.data.message || 'Failed to load members');
        }
      } catch (e) {
        this.showAlert('failed', e.message || 'Failed to load members');
      } finally {
        this.loading = false;
      }
    },

    async loadCounties() {
      try {
        const res = await executeJson({ "function": "getCounties" }, authUrl);
        if (res.data.success) {
          this.counties = res.data.data.counties || [];
        }
      } catch (e) {
        console.error("Failed to load counties:", e);
      }
    },

    async loadFilterSubCounties(countyId) {
      try {
        const res = await executeJson({ "function": "getSubCounties", "countyId": countyId }, authUrl);
        if (res.data.success) {
          this.filterSubCounties = res.data.data.subCounties || [];
        }
      } catch (e) {
        console.error("Failed to load sub-counties:", e);
      }
    },

    async loadFilterWards(subCountyId) {
      try {
        const res = await executeJson({ "function": "getWards", "subCountyId": subCountyId }, authUrl);
        if (res.data.success) {
          this.filterWards = res.data.data.wards || [];
        }
      } catch (e) {
        console.error("Failed to load wards:", e);
      }
    },

    // ==================== FILTER METHODS ====================

    performSearch() {
      this.searchQuery = this.localSearchQuery;
      this.currentPage = 1;
      this.loadMembers();
    },

    debounceSearch() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => { this.performSearch(); }, 500);
    },

    async onFilterCountyChange() {
      this.filters.subCountyId = '';
      this.filters.wardId = '';
      this.filterSubCounties = [];
      this.filterWards = [];
      if (this.filters.countyId) {
        await this.loadFilterSubCounties(this.filters.countyId);
      }
      this.applyFilters();
    },

    async onFilterSubCountyChange() {
      this.filters.wardId = '';
      this.filterWards = [];
      if (this.filters.subCountyId) {
        await this.loadFilterWards(this.filters.subCountyId);
      }
      this.applyFilters();
    },

    applyFilters() {
      this.currentPage = 1;
      this.loadMembers();
    },

    resetFilters() {
      this.filters = { status: '', enrollmentType: '', planId: '', countyId: '', subCountyId: '', wardId: '', cardIssued: '' };
      this.filterSubCounties = [];
      this.filterWards = [];
      this.dateRange = { startDate: '', endDate: '' };
      this.applyFilters();
    },

    applySort() {
      this.showSortModal = false;
      this.currentPage = 1;
      this.loadMembers();
    },

    clearSort() {
      this.sortField = '';
      this.sortDirection = 'asc';
      this.applySort();
    },

    // ==================== UTILITY METHODS ====================

    getColumnLabel(column) {
      const labels = {
        memberCode: 'CBHI Number', name: 'Name', enrollmentType: 'Enrollment Type',
        plan: 'Plan Category', professional: 'Profession', county: 'County',
        ward: 'Ward', location: 'Location', address: 'Address', familySize: 'Household Size',
        registrationDate: 'Registration Date', lastPayment: 'Last Payment',
        cardIssued: 'Card Issue Notes', status: 'Status', nextPayment: 'Expiry Date', annualPayment: 'Annual Payment'
      };
      return labels[column] || column;
    },

    showAllColumns() {
      Object.keys(this.visibleColumns).forEach(key => { this.visibleColumns[key] = true; });
    },

    hideAllColumns() {
      Object.keys(this.visibleColumns).forEach(key => { this.visibleColumns[key] = false; });
    },

    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.loadMembers();
      }
    },

    getPlanName(planId) {
      const plan = this.plansMap[planId];
      return plan ? plan.plan_name : 'No Plan';
    },

    getPlanType(planId) {
      const plan = this.plansMap[planId];
      return plan ? plan.plan_type.charAt(0).toUpperCase() + plan.plan_type.slice(1) : '';
    },

    calculateDependentStatus(member) {
      const numDependents = Math.max(0, (parseInt(member.household_size) || 1) - 1);
      return numDependents === 0 ? 'No deps' : `${numDependents} deps`;
    },

    formatNumber(num) {
      return new Intl.NumberFormat().format(num || 0);
    },

    formatCurrency(amount) {
      return `${this.currencySymbol} ${new Intl.NumberFormat().format(amount || 0)}`;
    },

    exportData() {
      this.showAlert('info', 'Exporting current page...');
      // Export implementation
    },

    startExportAll() {
      this.showAlert('info', 'Starting full export...');
      // Export all implementation
    },

    // ==================== EDIT PAYMENT DATE METHODS ====================

    openEditPaymentDateModal(member) {
      if (!member.last_payment_date) {
        this.showAlert('info', 'This member has no payment to edit');
        return;
      }

      this.editPaymentData = {
        member: member,
        newDate: member.last_payment_date ? member.last_payment_date.split('T')[0] : '',
        loading: false,
        error: null
      };

      const modal = new bootstrap.Modal(document.getElementById('editPaymentDateModal'));
      modal.show();
    },

    async updatePaymentDate() {
      if (!this.editPaymentData.newDate) {
        this.editPaymentData.error = 'Please select a date';
        return;
      }

      const newDate = new Date(this.editPaymentData.newDate);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      newDate.setHours(0, 0, 0, 0);

      if (newDate > today) {
        this.editPaymentData.error = 'Payment date cannot be in the future';
        return;
      }

      this.editPaymentData.loading = true;
      this.editPaymentData.error = null;

      try {
        const res = await executeJson({
          "function": "updateLastPaymentDate",
          "memberId": this.editPaymentData.member.member_id,
          "lastPaymentDate": this.editPaymentData.newDate
        }, authUrl);

        if (res.data.success) {
          const memberIndex = this.members.findIndex(m => m.member_id === this.editPaymentData.member.member_id);
          if (memberIndex !== -1) {
            this.members[memberIndex].last_payment_date = this.editPaymentData.newDate;
          }

          const modal = bootstrap.Modal.getInstance(document.getElementById('editPaymentDateModal'));
          modal.hide();

          this.showAlert('success', res.data.message || 'Payment date updated successfully');
          await this.loadMembers();
        } else {
          this.editPaymentData.error = res.data.message || 'Failed to update payment date';
        }
      } catch (error) {
        this.editPaymentData.error = error.message || 'Error updating payment date';
      } finally {
        this.editPaymentData.loading = false;
      }
    },

    logout() {
      localStorage.removeItem('authToken');
      sessionStorage.clear();
      router.push('/login');
    }
  }
};
</script>

<style scoped>
.search-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  color: #74788d;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.bg-purple {
  background-color: #6f42c1 !important;
}

.page-link {
  cursor: pointer;
}

.disabled .page-link {
  cursor: not-allowed;
}
</style>